import { Locales } from '@griply/types';
import {
  getAdditionalUserInfo,
  GoogleAuthProvider,
  signInWithCredential,
} from 'firebase/auth';
import i18n from 'i18next';
import { finishUserSignup } from 'shared/services/backend-api/finish-user-signup';
import { getAuthentication } from 'shared/services/backend-api/helpers';
import { processOnboardingAnswers } from 'shared/services/backend-api/process-onboarding-answers';
import {
  clearNonce,
  clearOnboardingAnswers,
} from 'shared/services/local-storage';

const GOOGLE_ID_TOKEN_PARAM = 'googleIdToken';

export const getSearchParamGoogleIdToken = (): string | undefined => {
  const params = new URLSearchParams(window.location.search);
  return params.get(GOOGLE_ID_TOKEN_PARAM) ?? undefined;
};

export const removeGoogleIdTokenFromUrl = (): void => {
  const url = new URL(window.location.href);
  url.searchParams.delete(GOOGLE_ID_TOKEN_PARAM);
  window.history.replaceState({}, '', url.toString());
};

export const finishGoogleSignIn = async (idToken: string): Promise<void> => {
  removeGoogleIdTokenFromUrl();

  const auth = await getAuthentication();
  const credential = GoogleAuthProvider.credential(idToken);
  const result = await signInWithCredential(auth, credential);
  clearNonce();

  const isNewUser = getAdditionalUserInfo(result)?.isNewUser ?? false;
  if (!isNewUser) {
    return;
  }

  await finishUserSignup({
    uid: auth.currentUser?.uid,
    name: result.user.displayName ?? undefined,
    locale: (i18n.resolvedLanguage ?? i18n.language) as Locales,
  });
  await processOnboardingAnswers();
  clearOnboardingAnswers();
};
